import { render, staticRenderFns } from "./site_record.vue?vue&type=template&id=fbdbd22a&scoped=true&"
import script from "./site_record.vue?vue&type=script&lang=js&"
export * from "./site_record.vue?vue&type=script&lang=js&"
import style0 from "./site_record.vue?vue&type=style&index=0&id=fbdbd22a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbdbd22a",
  null
  
)

export default component.exports